import React, { useContext } from 'react'
import { Link } from 'react-router-dom'
import { generateCreateUrl } from '#src/services/path'
import {
  StartExpertConsumerConversationComponent,
  StartExpertConsumerConversationMutationFn,
  ExpertForChatButtonComponent
} from '#src/generated/graphql'
import Logger from '#src/services/logger'
import { toast } from 'react-toastify'
import { IdentityContext } from '#src/containers/Identity'
import { useHistory } from 'react-router-dom'

interface ExpertChatButtonProps {
  children: (
    startExpertConsumerConversation?: StartExpertConsumerConversationMutationFn,
    loading?: boolean
  ) => JSX.Element
  className?: string
  expertId?: string
  guestLocation?: string
}

const ExpertChatButton: React.SFC<ExpertChatButtonProps> = ({
  children,
  className,
  expertId,
  guestLocation = generateCreateUrl({
    sourceKey: 'expert-chat-button',
    pathIntent: 'register'
  })
}) => {
  const { myself } = useContext(IdentityContext)
  const history = useHistory()

  if (!myself || !expertId) {
    return (
      <Link to={guestLocation} className={className}>
        {children()}
      </Link>
    )
  }

  return (
    <ExpertForChatButtonComponent
      variables={{
        vanityIdOrId: expertId
      }}
    >
      {({ data }) => {
        if (data && data.findExpert) {
          const expert = data.findExpert

          // Don't allow starting a conversation with inactive expert or assistant, direct them to the path
          if (!expert.active || expert.expertAttributes.placeholderExpert) {
            return (
              <Link to={guestLocation} className={className}>
                {children()}
              </Link>
            )
          }
          return (
            <StartExpertConsumerConversationComponent
              onCompleted={response => {
                if (
                  response &&
                  response.startExpertConsumerConversation &&
                  response.startExpertConsumerConversation.conversation
                ) {
                  return history.push(
                    `/inbox/${response.startExpertConsumerConversation.conversation.id}`
                  )
                } else {
                  Logger.captureException('Error starting conversation with expert', {
                    errorMessage: response.startExpertConsumerConversation.error
                  })

                  toast.error('Error starting conversation! Please try again.')
                }
              }}
              variables={{
                input: {
                  consumerId: myself.id,
                  expertId: expert.id
                }
              }}
            >
              {(startExpertConsumerConversation, { loading }) => {
                return children(startExpertConsumerConversation, loading)
              }}
            </StartExpertConsumerConversationComponent>
          )
        }

        return null
      }}
    </ExpertForChatButtonComponent>
  )
}

export default ExpertChatButton
